module.exports = __webpack_public_path__ + "static/media/ic_head6.de9b6c40.png";